import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalLoadingService } from './core/services/global-loading.service';
import { GlobalAlertService } from './core/services/global-alert.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('flwx-web');
  private loadingService = inject(GlobalLoadingService);
  private alertService = inject(GlobalAlertService);
  
  public isLoading = this.loadingService.isLoading;
  public alertState = this.alertService.alertState;

  clearAlert() {
    this.alertService.clearAlert();
  }
}
